export enum Style
{
    bold = 'bold' ,
    italic = 'italic',
    underline = 'underline',
    clear='clear'
}

